<template>
  <div class="main-con el-main">
    <nav-breadcrumb :menu="[{label: '贷款清算明细表'}]"/>
<!--    <el-row class="xzpadd10 bg-purple">
      <data-table
        :tableData="listData"
        :columns="listColumns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters="filters"
        :actions="actions"
        :is-pagination-show="false"
      ></data-table>
    </el-row>-->
  <!--  <el-dialog
      title="导出确认"
      :visible.sync="dialogVisible"
      width="40%">

    </el-dialog>-->
    <el-form :model="reportForm"  ref="reportForm" label-width="150px">
      <el-row :gutter="10" class="bg-purple xamhtrpg">
        <el-col :span="12">
          <el-form-item label="渠道商：" prop="d__dealerId" :rules="{required: true, message: '渠道商不能为空'}">
            <el-select placeholder="请选择渠道商" v-model.trim="reportForm.d__dealerId" filterable>
              <el-option :label="item.label" :value="item.value" v-for="(item,idx) in dealerOptions" :key="idx"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="应还款月：" prop="plan__repayDate" :rules="{required: true, message: '应还款月不能为空'}">
            <el-date-picker
              v-model="reportForm.plan__repayDate"
              value-format="yyyy-MM-01 00:00:00"
              type="month"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="税差率：" prop="taxFactor" :rules="{required: true, message: '税差率不能为空'}">
            <el-input v-model="reportForm.taxFactor" type="number" style="width: 35%"></el-input>%
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="tr xzmt">
      <el-button type="primary" @click="onSubmit('reportForm')">导出</el-button>
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "FangReportingFinanceList",
      data() {
        return {
          reportForm:{
            d__dealerId:'',
            plan__repayDate:'',
            taxFactor:0
          },
          dealerOptions:[],
          dialogVisible:false,
          transactionStatus: this.$route.query['fi.transactionStatus'],
          page: 1,
          pageSize: 20,
          listData: {},
          listColumns: [
            {
              name: '序号',
              type: 'index'
            },
            {
              name: '贷款编号',
              field: 'fi__transactionNo'
            },
            {
              name: '客户姓名',
              field: 'c__customerName'
            },
            {
              name: '客户手机号',
              field: 'c__customerContactNo'
            },
            {
              name: '渠道商',
              field: 'd__dealerName',
            },
            /*{
              name: '核定贷款金额',
              field: 'asm__approvedAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },*/
           /* {
              name: '贷款金额',
              field: 'fi__totalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },*/
            {
              name: '贷款合同利率',
              field: 'fi__interestRate',
            /*  formatter: function (r,c,v) {
                return v+"%("+Status2CN(r.fi__interestType)+")"
              }*/
            },

            /*{
              name: '放款日期',
              field: 'fi__startDate',
              formatter: function (r,c,v) {
                if(v)
                  return moment(v).format('YYYY-MM-DD')
              }
            },*/
            /*{
              name: '到期日',
              field: 'fi__endDate',
              formatter: function (r,c,v) {
                if(v)
                  return moment(v).format('YYYY-MM-DD')
              }
            },*/
            {
              name: '总期数',
              field: 'fi__repaymentCount',

            },
            {
              name: '还款期数',
              field: 'plan__sequenceNo',

            },
            {
              name: '应还款日',
              field: 'plan__repayDate',
              formatter: function (r,c,v) {
                if(v)
                  return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              name: '实还款日',
              field: 're__repayDate',
              formatter: function (r,c,v) {
                if(v)
                  return moment(v).format('YYYY-MM-DD')
              }
            },
            /*{
              name: '应收本金',
              field: 'plan__principalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              name: '应收利息',
              field: 'plan__interestAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },*/

            {
              name: '实收本金',
              field: 're__principalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },

            {
              name: '实收利息',
              field: 're__interestAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            /*{
              name: '逾期罚息',
              field: 're__overdueFine',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },*/
            /*{
              name: '贷款余额',
              field: 'rebate__principalBalance',
              formatter: function (r,c,v) {
                return formatMoney((Number(v)||0) - (Number(r.re__principalAmount)||0) )
              }
            },*/

            /*{
              name: '提前还款违约金',
              field: 're__penaltyAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },

            {
              name: '服务费',
              field: 're__lendingFeeAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              name: '其他费用',
              field: 're__otherAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },*/
            /*{
              name: '多收费用',
              field: 're__excessAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              name: '减免费用',
              field: 're__deductionAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              name: '上期余额',
              field: 're__exBalanceAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },*/
            {
              name: '实际还款',
              field: 're__repayAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            /*{
              name: '还款方式',
              field: 'rex__channel',

            },*/
            /*{
              name: '实际还款时间',
              field: 're__repayDate',
              formatter: function (r,c,v) {
                if(v)
                  return moment(v).format('YYYY-MM-DD ')
              }
            },*/
            {
              name: '留存收益率',
              field: 'dfi__interestRate',
   /*           formatter: function (r,c,v) {
                return v+"%("+Status2CN(r.dfi__interestType)+")"
              }*/

            },
            {
              name: '应付渠道商',
              field: 're__rebateAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
          ],
          filters: {
            form: {
              plan__repayDate:[],
              d__dealerId:'',
              c__customerName:'',
              fi__transactionNo:'',
              u__customerContactNo:'',
            },
            rules: {
              plan__repayDate:{
                required:true,
                message: '不能为空'
              },
              d__dealerId:{
                required:true,
                message: '不能为空'
              },
            },
            columns: [
              {
                label: '贷款编号',
                component: 'el-input',
                field: 'fi__transactionNo',
              },
              {
                label: '客户姓名',
                component: 'el-input',
                field: 'c__customerName',
              },
              {
                label: '客户手机号',
                component: 'el-input',
                field: 'u__customerContactNo',

              },
              {
                label: '应还款月',
                component: 'el-date-picker',
                field: 'plan__repayDate',
                op:'gteq',
                type: 'month',
                valueFormat:'yyyy-MM-01 00:00:00',
                span: 12,

              },

            /*  {
                label: '应还款日',
                component: 'date-range-picker',
                field: 'plan__repayDate',
                op: ['gteq', 'lteq'],
              },*/
              {
                label: '渠道商',
                component: 'el-select',
                field: 'd__dealerId',
                options:[]

              },
            ],
            onSubmit:()=>{
              this.page = 1
              this.getReportingFinanceList()
            }
          },

          actions: [
            {
              label: '导出',
              clickHandler:()=>{
                this.dialogVisible = true

              }
            }
          ],
        }
      },
      computed : {
        filterParams: {
          get: function() {
            return {
            /*  pageSize: this.pageSize,
              pageOffset: (this.page - 1) * this.pageSize,*/
              // 'xlist.sort.dataField': 'fi.transactionDate',
              // 'xlist.sort.order': 'desc'
            }
          },
          set:function (newVal) {

          }
        }
      },
      watch: {
        filterParams: function () {
          this.getReportingFinanceList()
        }
      },
      mounted() {
       // this.getReportingFinanceList()
        this.getDealerList()
      },
      methods: {
        getReportingFinanceList: function () {
          xhr.getFangReportingFinanceList(
            Object.assign({pageSize:0}, {}, xmlBuildQuery(this.filters)),
            res=> {
              try {
                this.listData = res.data
              }catch(e){

              }
            })

        },
        getDealerList: function () {
          xhr.getDealerList(
            Object.assign({pageSize:0}, this.filterParams, xmlBuildQuery(this.filters)),
            res=> {
              try {
                this.dealerOptions = res.data.data.map(item=>{
                  return {
                    label: item.d__dealerName,
                    value:item.d__dealerId,
                  }
                })
              }catch(e){

              }
            })

        },
        onSubmit:function (formName) {
          this.$refs[formName].validate(valid=> {
            if (valid) {
              if(this.reportForm.taxFactor>=0&&this.reportForm.taxFactor<=100){
                let routeData = this.$router.resolve({
                  path: '/ix/fang/financing/reporting/Rebate.List?format=xls',
                  query: Object.assign({}, this.filterParams, {
                    'xlist.search.d.dealerId':this.reportForm.d__dealerId,
                    'xlist.search.d.dealerId.op':'eq',
                    'xlist.search.plan.repayDate':this.reportForm.plan__repayDate,
                    'xlist.search.plan.repayDate.op':'gteq',
                    'taxFactor':this.reportForm.taxFactor,
                  })
                });
                console.log(routeData)
                console.log(this.reportForm.plan__repayDate)
                window.open(routeData.href.replace('#/', '/'), '_blank');
              }else{
                alert("税率差要大于等于0小于等于100")
              }

            }
          })
        },
        onClose:function () {
          this.dialogVisible = false
          this.reportForm.taxFactor = 0
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/FangReportingFinanceList.vue